import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import axios from "axios";
import './login.css';
import { FaEye, FaEyeSlash } from "react-icons/fa"; // FontAwesome icons
import { useLocation } from 'react-router-dom';
const baseUrl = process.env.REACT_APP_API_BASE_URL;
const LoginComponent = () => {
    const [UserName, setUserName] = useState("");
    const [Password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [user, setUser] = useState(null);
    const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
    const navigate = useNavigate(); // Initialize navigate
    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${baseUrl}api/Account/LoginUser`, {
                UserName: UserName,
                Password: Password, 
                
                // RouteLoc: "FrontEnd"
            });
            // console.log("login responce",response)  

            // Check if the response status is 'success'
            if (response.data.Status === 200) {
               

                const token = response.data.Data.Token;
            
                // console.log("token:", token);
            
                localStorage.setItem("bearerToken", token);
            
                // redirect to home
                navigate("/home");
            
            } else {
                setError("Invalid credentials");
            
                setUserName(""); // Clear the UserName field
                setPassword(""); // Clear the Password field
                setTimeout(() => {
                    setError("");
                }, 5000);
            }
        } catch (error) {
            setError("Error during login. Please try again.");
            setUserName(""); // Clear the UserName field
            setPassword(""); // Clear the Password field
        }
    };
    const getUser = async (token) => {
        try {
            const response = await fetch(`https://cbtflightmidapi.blueberry-travel.com/api/Employee/getUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                if (response.status === 401) {
                    localStorage.removeItem('bearerToken');
                    localStorage.removeItem('policies');
                    sessionStorage.removeItem('policies');
                    localStorage.removeItem('user');
                    sessionStorage.clear();
                    window.location.href = '/';
                }
                throw new Error(`Error ${response.status}: ${response.statusText}`);
            };
            const result = await response.json();
            setUser(result.data);
            console.log(result.data);
            if (result.data.isActive) {
                localStorage.setItem('user', JSON.stringify(result.data));
                navigate("/"); // Redirect to '/home'
            }
            else {
                localStorage.removeItem('bearerToken');
                localStorage.removeItem('policies');
                sessionStorage.removeItem('policies');
                localStorage.removeItem('user');
                sessionStorage.clear();
                alert("The user is de-activated, Please contact administrator.");
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const settings = {
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    const images = [
        { src: "./assets/images/slider1.png", alt: "Slide 1" },
        { src: "./assets/images/slider2.png", alt: "Slide 2" },
        { src: "./assets/images/slider3.png", alt: "Slide 3" },
        { src: "./assets/images/slider4.png", alt: "Slide 4" },
    ];

    return (
        <div className="mainContainerLoginPage">
            <div className="slider-container">
                <Slider{...settings}>
                    {images.map((image, index) => (
                        <div key={index}>
                            <img src={image.src} alt={image.alt} className="loginimageSlider" />
                        </div>
                    ))}
                </Slider>
            </div>

            <div className="login-form">
                <div className="login-form-container">
                    <div className="BB-logo">
                        <img src="./assets/logoBBT.png" alt="" />
                    </div>
                    <form onSubmit={handleSubmit} className="">
                        <h2 className="loginHeading">LOG IN</h2>
                        <div>
                            <input
                                className="loginInput"
                                type="text"
                                placeholder="User ID"
                                value={UserName}
                                onChange={(e) => setUserName(e.target.value)}
                                required
                            />
                        </div>

                        <div className="password-container">
                            <input
                                className="loginInput"
                                type={showPassword ? "text" : "password"}
                                placeholder="Password"
                                value={Password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <span
                                className="password-toggle-icon"
                                onClick={() => setShowPassword(!showPassword)}
                            >
                                
                            </span>
                        </div>

                        <div class="remember-forgot-container">
                            <label class="remember-me">
                                <input type="checkbox"/>
                                    <span>Remember Me</span>
                            </label>

                            <a href="#" class="forgot-pass">Forget Password?</a>
                        </div>

                        {error && <p className="error-message">{error}</p>}

                        <button type="submit" className="login-button">LOG IN</button>
                    </form>
                </div>

            </div>
        </div>
    );
};

export default LoginComponent;
